var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxCompetingAgainstOthers01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-competing-against-others-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,4.07C22.77,3.13,21.9,2,19,2H5C2.1,2,1.23,3.13,1,4.07.46,6.37,3.5,9.18,6,10.6V11c0,1.66,1.86,3.68,3.5,4.86A5.76,5.76,0,0,0,6,21v1H18V21a5.76,5.76,0,0,0-3.5-5.14C16.14,14.68,18,12.66,18,11v-.4C20.5,9.18,23.54,6.37,23,4.07ZM3,4.53C3,4.35,3.48,4,5,4H6V8.23C4.05,6.88,2.79,5.2,3,4.53ZM15.85,20H8.15c.53-1.67,2.34-2.5,3.49-2.87a1.24,1.24,0,0,0,.36-.19,1.24,1.24,0,0,0,.36.19C13.51,17.5,15.32,18.33,15.85,20ZM16,11c0,1-2.25,3.28-3.7,3.83A1.11,1.11,0,0,0,12,15a1.11,1.11,0,0,0-.3-.17C10.25,14.28,8,12,8,11V4h8Zm2-2.77V4h1c1.52,0,2,.35,2.05.53C21.21,5.2,20,6.88,18,8.23Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxCompetingAgainstOthers01);
export default __webpack_public_path__ + "static/media/24px-competing-against-others-01.1bcef59ffe7ae49e9dcae5d5493df0d7.svg";
export { ForwardRef as ReactComponent };